<template>
  <v-app>
    <slot name="header">
      <base-header />
    </slot>
    <v-content class="grey lighten-5">
      <v-container class="base__container">
          <slot name="sub-header">
              <title-bar />
          </slot>
          <slot name="container">
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <slot name="content"></slot>
                    </v-col>
                </v-row>
            </v-container>
          </slot>
      </v-container>
    </v-content>
    <slot name="footer">
      <base-footer />
    </slot>
    <slot name="alert-bag">
      <alert-bag :alerts="findAll" />
    </slot>
  </v-app>
</template>

<script>
import TitleBar from './TitleBar'
import BaseHeader from './BaseHeader'
import BaseFooter from './BaseFooter'
import AlertBag from '../alerts/AlertBag'
import { mapState } from 'pinia'
import { useAlertStore } from '@/stores'

export default {
  name: 'base-content',
  components: {
    TitleBar,
    BaseHeader,
    BaseFooter,
    AlertBag,
  },
  computed: {
    ...mapState(useAlertStore, [
      'findAll',
    ]),
  },
}
</script>
